"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.executeBathQueryReceiver = exports.scheduleQueryReceiver = exports.executeBatchQuery = exports.scheduleQuery = exports.batchQuery = void 0;
var tslib_1 = require("tslib");
var invoker_1 = require("@drapejs/invoker");
var graphql_request_1 = require("graphql-request");
var consola_1 = tslib_1.__importDefault(require("consola"));
var index_1 = require("./index");
var runtime_context_1 = require("@drapejs/runtime-context");
var queryQueue = [];
/**
 * Combines multiple Litium GraphQL sub-queries into a single query. All fields are expected to be part of Session query graph type
 * @param url The value to pass to url parameter of session field
 * @param queries The sub-queries/fields to query on the session graph type
 */
function batchQuery(cache, url, headers) {
    if (headers === void 0) { headers = undefined; }
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var currentQueue, variablesSignature_1, queryFragments_1, variablesPayload_1, i_1, fragments_1, bigQuery, result_1, err_1;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    if ((queryQueue === null || queryQueue === void 0 ? void 0 : queryQueue.length) == 0) {
                        return [2 /*return*/];
                    }
                    currentQueue = queryQueue;
                    queryQueue = [];
                    variablesSignature_1 = [];
                    queryFragments_1 = [];
                    variablesPayload_1 = {
                        url: url,
                    };
                    i_1 = 0;
                    fragments_1 = new Set();
                    currentQueue.forEach(function (query) {
                        var alias = "q" + i_1;
                        query.__alias = alias;
                        if (query.query.fragments) {
                            query.query.fragments.forEach(function (f) { return fragments_1.add(f); });
                        }
                        if (query.variables) {
                            for (var _i = 0, _a = Object.entries(query.variables); _i < _a.length; _i++) {
                                var _b = _a[_i], key = _b[0], value = _b[1];
                                variablesSignature_1.push("$".concat(alias, "_").concat(key, ": ").concat(value.type));
                                variablesPayload_1["".concat(alias, "_").concat(key)] = value.value;
                            }
                        }
                        queryFragments_1.push(alias +
                            ": " +
                            query.query.query.replace(/\$/g, "$" + alias + "_").trim());
                        i_1 += 1;
                    });
                    bigQuery = (0, graphql_request_1.gql)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n      query batch($url: String!,", ") {\n        session(url: $url) {\n          ", "\n        }\n      }"], ["\n      query batch($url: String!,", ") {\n        session(url: $url) {\n          ", "\n        }\n      }"])), variablesSignature_1.join(","), queryFragments_1.join("\n"));
                    return [4 /*yield*/, (0, index_1.request)(cache, {
                            query: bigQuery,
                            fragments: fragments_1,
                        }, variablesPayload_1, headers)];
                case 1:
                    result_1 = _a.sent();
                    currentQueue.forEach(function (query) {
                        var alias = query.__alias;
                        var r = result_1.data.session[alias];
                        if (r) {
                            cache.setItem(query.cacheKey, r);
                            if ((0, runtime_context_1.isNode)()) {
                                cache.setItem(query.cacheKey + ":res", result_1);
                            }
                        }
                    });
                    return [3 /*break*/, 3];
                case 2:
                    err_1 = _a.sent();
                    console.error(err_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    });
}
exports.batchQuery = batchQuery;
/** Schedules a GraphQL query to be sent together with the next fetchPage or executeBatch */
exports.scheduleQuery = (0, invoker_1.defineCommand)("scheduleQuery");
exports.executeBatchQuery = (0, invoker_1.defineCommand)("executeBatchQuery");
exports.scheduleQueryReceiver = (0, invoker_1.defineReceiver)(exports.scheduleQuery, function (command, data) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var fragments;
        return tslib_1.__generator(this, function (_a) {
            fragments = command.fragments || [];
            consola_1.default.trace("Litium: Scheduling batched query, (queue: ".concat(queryQueue.length, ")"));
            queryQueue.push({
                query: index_1.query.apply(void 0, tslib_1.__spreadArray([command.query], fragments, false)),
                cacheKey: command.cacheKey,
                variables: command.variables,
            });
            return [2 /*return*/, data];
        });
    });
});
exports.executeBathQueryReceiver = (0, invoker_1.defineReceiver)(exports.executeBatchQuery, function (command, data) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, batchQuery(this.cache, "".concat(command.protocol, "//").concat(command.host).concat(command.path), command.headers)];
                case 1:
                    _a.sent();
                    return [2 /*return*/, data];
            }
        });
    });
}, "litium");
var templateObject_1;
//# sourceMappingURL=batch-query.js.map